<template>
  <FilterPracticeOptions v-model="selected" :options="options">
    Status
  </FilterPracticeOptions>
</template>

<script setup>
import { ref, computed, onMounted, watchEffect } from 'vue';

const props = defineProps({'modelValue': Array});
const emits = defineEmits(['update:modelValue']);
const selected = ref(new Array);

const emitter = (value) => emits('update:modelValue', value);

const watcher = watchEffect(() => emitter(selected.value));

const bookmarked = {value: 'bookmarked', label: 'Gemerkte Methoden'};
const application = {value: 'applied', label: 'Dauerhaft in Anwendung'};
const actions = {value: 'actions', label: 'Mit Anleitung'};
const rejected = {value: 'rejected', label: 'Ausgeblendet'};

const options = [bookmarked, application, actions, rejected];
</script>
